import ApiRequestManagerInstance from '../ApiRequestManager';
import IAutoCompleteRequest, {
  AutoComplete,
} from '../../types/interfaces/search';
import { store } from '../../store/store';

const MAX_QUERIES = 18;

function autoCompleteRequest(query: string) {
  const promise = new Promise<AutoComplete[]>(async (resolve) => {
    try {
      const { channels, user } = store.getState();
      const response: IAutoCompleteRequest =
        (await ApiRequestManagerInstance.get({
          endpoint: {
            url: 'apiUrl',
            version: 'v6',
            section: user?.isAnonymous ? 'mediafree' : 'media',
            subsection: 'autocomplete',
            type: 'autocomplete',
            params: query,
          },
        })) as unknown as IAutoCompleteRequest;

      const queryList: AutoComplete[] = [];
      response.data.channels.forEach((item) => {
        if (
          channels.channelsData?.find(
            (channel) => channel.code === item.channelCode
          ) &&
          queryList.length < MAX_QUERIES
        )
          queryList.push(item);
      });
      response.data.medias.forEach((item) => {
        if (
          channels.channelsData?.find(
            (channel) => channel.id === item.channel
          ) &&
          queryList.length < MAX_QUERIES
        )
          queryList.push(item);
      });
      resolve(Array.from(new Set(queryList))); // Creating a set will keep unique values only
    } catch (e) {
      console.error(e);
      resolve([]);
    }
  });

  return promise;
}

export default autoCompleteRequest;
